import { render, staticRenderFns } from "./MapResetExtentButton.vue?vue&type=template&id=5c4855a4"
import script from "./MapResetExtentButton.vue?vue&type=script&lang=js"
export * from "./MapResetExtentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports